// src/app/theme/theme-presets.ts
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';
import Lara from '@primeuix/themes/lara';
import { APP_THEME_CONFIG } from '../app.constants';


// STORE THE COLOR IN A VARIABLE FOR CLEANER CODE
const primaryColor = APP_THEME_CONFIG.defaultPrimary;

// Export the base themes for your Header Switcher

export const AuraPreset = definePreset(Aura, {

    primitive: {
    },
    semantic: {
        primary: {
            50: `{${primaryColor}.50}`,
            100: `{${primaryColor}.100}`,
            200: `{${primaryColor}.200}`,
            300: `{${primaryColor}.300}`,
            400: `{${primaryColor}.400}`,
            500: `{${primaryColor}.500}`,
            600: `{${primaryColor}.600}`,
            700: `{${primaryColor}.700}`,
            800: `{${primaryColor}.800}`,
            900: `{${primaryColor}.900}`,
            950: `{${primaryColor}.950}`
        },
    }
});


export const LaraPreset = definePreset(Lara, {

    primitive: {
    },
    semantic: {
        primary: {
            50: `{${primaryColor}.50}`,
            100: `{${primaryColor}.100}`,
            200: `{${primaryColor}.200}`,
            300: `{${primaryColor}.300}`,
            400: `{${primaryColor}.400}`,
            500: `{${primaryColor}.500}`,
            600: `{${primaryColor}.600}`,
            700: `{${primaryColor}.700}`,
            800: `{${primaryColor}.800}`,
            900: `{${primaryColor}.900}`,
            950: `{${primaryColor}.950}`
        },
    }
});

// 2. Export your Custom Forest Theme (which will be your default)

// NEW: Build the "Forest" Theme extending Aura
export const ForestPreset = definePreset(Aura, {
    primitive: {
        borderRadius: {
            none: '0',
            xs: '4px',
            sm: '6px',
            md: '10px',  // Standard components (Buttons, Inputs, Dropdowns) use 'md'
            lg: '20px',  // Large components (Cards, Modals) use 'lg' or 'xl'
            xl: '30px'
        }
    },
    semantic: {
        primary: {
            50: `{${primaryColor}.50}`,
            100: `{${primaryColor}.100}`,
            200: `{${primaryColor}.200}`,
            300: `{${primaryColor}.300}`,
            400: `{${primaryColor}.400}`,
            500: `{${primaryColor}.500}`,
            600: `{${primaryColor}.600}`,
            700: `{${primaryColor}.700}`,
            800: `{${primaryColor}.800}`,
            900: `{${primaryColor}.900}`,
            950: `{${primaryColor}.950}`
        },
        colorScheme: {
            light: {
                // 2. Override the Surface Colors (Use warm 'stone' grays instead of cool 'slate' grays)
                surface: {
                    0: '#ffffff',
                    50: '{stone.50}',
                    100: '{stone.100}',
                    200: '{stone.200}',
                    300: '{stone.300}',
                    400: '{stone.400}',
                    500: '{stone.500}',
                    600: '{stone.600}',
                    700: '{stone.700}',
                    800: '{stone.800}',
                    900: '{stone.900}',
                    950: '{stone.950}'
                }
            },
            dark: {
                surface: {
                    0: '#ffffff',
                    50: '{stone.50}',
                    100: '{stone.100}',
                    200: '{stone.200}',
                    300: '{stone.300}',
                    400: '{stone.400}',
                    500: '{stone.500}',
                    600: '{stone.600}',
                    700: '{stone.700}',
                    800: '{stone.800}',
                    900: '{stone.900}',
                    950: '{stone.950}'
                }
            }
        }
    },
    components: {
        // --- BUTTONS ---
        button: {
            root: {
                paddingY: '0.4rem',
                paddingX: '1.5rem'
            }
        },

        // --- FORM FIELDS (Inputs, Dropdowns) ---
        inputtext: {
            root: {
                paddingY: '0.4rem',
                paddingX: '1rem'
            }
        },
        select: {
            root: {
                paddingY: '0.4rem',
                paddingX: '1rem'
            }
        },

        // --- DATA TABLES (High-Density Desktop View) ---
        datatable: {
            bodyCell: {
                padding: '0.5rem 0.75rem'
            },
            headerCell: {
                padding: '0.5rem 0.75rem'
            }
        },

        tag: {
            root: {
                fontSize: '13px',
            }
        },

        card: {
            root: {
                borderRadius: '0.75rem'
            },
            body: {
                padding: '1.25rem',
            },
        }
    }
});

// 3. Centralized Selection Logic
const presetMap: Record<string, any> = {
    'Aura': AuraPreset,
    'Lara': LaraPreset,
    'Forest': ForestPreset
};


export const APP_PRIMARY_THEME = presetMap[APP_THEME_CONFIG.defaultPreset] || AuraPreset;

